import axios from 'axios';

import cfac22 from '../cfac22';

export async function validateCode(code, cellPhone, transactionId) {
  return new Promise((resolve, reject) => {
    Promise.resolve().
    then(() => {
      axios.
      post(
        cfac22('API_HOST_V2') + '/sms/validateSMS',
        {
          transactionId: transactionId,
          cellphone: cellPhone,
          code: code
        },
        {
          headers: { 'Full-Url': window.location.href }, withCredentials: true
        }
      ).
      then((result) => {
        console.log('RESULTADO VALIDATE SMS ===>', result);
        resolve(result);
      }).
      catch((error) => {
        //console.log('ERROR VALIDATE SMS ===>', error);
        reject(error);
      });
    }).
    catch((error) => {
      reject(error);
    });
  });
}
